import { render, staticRenderFns } from "./ContractWrapper.vue?vue&type=template&id=212c2432&"
import script from "./ContractWrapper.vue?vue&type=script&lang=js&"
export * from "./ContractWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ContractWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/ContractWrapper.vue
// module id = null
// module chunks = 